import { InjectionToken } from '@angular/core';

export const API_BASE_URI = new InjectionToken<string>('API_BASE_URI');
